import type { ReactNode } from 'react';
import { CUSTOMER_LOGOS_PER_COUNTRY } from 'register-partners-js/constants/customer-logos';
import styles from './styles.module.css';

export interface LogosBarProps {
  country: 'FR' | 'DE';
}

export function LogosBar({ country = 'FR' }: LogosBarProps): ReactNode {
  const logos = CUSTOMER_LOGOS_PER_COUNTRY[country];

  return (
    <div className={styles.logos} data-test-welcome-logos-bar>
      {logos.map(({ id, url, name }) => (
        <img alt={name} className={styles.logo} data-test-customer-logo={id} key={id} src={url} />
      ))}
    </div>
  );
}
